import HeroCrumbs from 'components/Sections/Hero/HeroCrumbs';
import { generateMetaTags } from 'helpers';
import { useAnimationWithWithoutScroll } from 'hooks/useAnimation';
import { useRef } from 'react';
import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';
import { contactIsLoading, selectContactTags } from 'store/slices/ContactsSlice';

const ContactsHero = ({ page, title, desc }) => {
    const container = useRef();
    const isLoading = useSelector(contactIsLoading);
    const contactTags = useSelector(selectContactTags);
    const metaTags = generateMetaTags(contactTags?.tags, 'meta');
    const metaTitle = generateMetaTags(contactTags?.tags, 'title');

    useAnimationWithWithoutScroll({
        item: '.contacts-title h1',
        container,
        dependencies: [isLoading],
        isLoading: isLoading,
    });
    useAnimationWithWithoutScroll({
        item: '.contacts-title .body1',
        container,
        dependencies: [isLoading],
        isLoading: isLoading,
    });
    return (
        <>
            <Helmet title={metaTitle ? `${metaTitle}` : title} meta={metaTags} />
            <section ref={container} className="inner-container contacts-title">
                <HeroCrumbs page={page} />
                <h1>{title}</h1>
                <div className="body1">{desc}</div>
            </section>
        </>
    );
};

export default ContactsHero;
